import { Text } from '@shopify/polaris'

import { formatDateTime } from '../utils/dateUtils'

interface FormattedDateTimeProps {
  date: string | Date | null | undefined
  fallback?: string
  variant?: 'bodySm' | 'bodyMd' | 'bodyLg'
  tone?: 'base' | 'subdued' | 'success' | 'critical' | 'text-inverse'
}

/**
 * Returns a formatted date using Polaris Text component with monospace styling
 */
export default function FormattedDateTime({
  date,
  fallback = 'N/A',
  variant = 'bodySm',
  tone = 'subdued',
}: FormattedDateTimeProps) {
  const formatted = date ? formatDateTime(date) : fallback

  return (
    <Text as="span" variant={variant} tone={tone} fontWeight="regular">
      {formatted}
    </Text>
  )
}
